import { useIntl } from "react-intl";
import { PopoverView } from "../popover";
import { SquareToggleButton } from "../squareToggleButton";
import { useState } from "react";
import { DocumentOnePageSparkle24Regular } from "@fluentui/react-icons";
import { useStyle } from "./style";
import { MessagingConversationSummaryPopover } from "@/components/organisms/messagingConversationSummary";
import { MessagingConversationSummaryProps } from "@/components/organisms/messagingConversationSummary/types";
import { getSummaryTooltip } from "@/common/helpers/summaryHelper";
import { useIsAicLockedForInteraction } from "@/hooks/aicLocking";

export const MessagingConversationSummaryButton = ({
	canGenerateSummary,
	interactionId,
	interactionType,
	interactionStartDate,
	firstAgentAssignedAt,
	summaryFeatureEnabled,
}: MessagingConversationSummaryProps) => {
	const intl = useIntl();
	const classes = useStyle();

	const [popoverOpen, setPopoverOpen] = useState(false);
	const isSummaryFeatureUnavailable = !summaryFeatureEnabled;
	const isAicLocked = useIsAicLockedForInteraction(firstAgentAssignedAt);

	return (
		<PopoverView
			trigger={
				<SquareToggleButton
					icon={<DocumentOnePageSparkle24Regular />}
					tooltip={
						isAicLocked
							? intl.formatMessage({ id: "Interaction.Buttons.FeatureNotAvailable" })
							: getSummaryTooltip(intl, isSummaryFeatureUnavailable, canGenerateSummary)
					}
					disabled={isSummaryFeatureUnavailable || !canGenerateSummary || isAicLocked}
					onClick={() => setPopoverOpen(!popoverOpen)}
					checked={popoverOpen}
				/>
			}
			content={
				<MessagingConversationSummaryPopover
					closePopover={() => setPopoverOpen(false)}
					isOpen={popoverOpen}
					interactionId={interactionId}
					interactionType={interactionType}
					interactionStartDate={interactionStartDate}
				/>
			}
			positioning={{ position: "below", align: "end", offset: { mainAxis: 8 } }}
			open={popoverOpen}
			classes={{ content: classes.summaryContent }}
		/>
	);
};
